import React from "react";
import MainRouters from "./view/MainRouters";
import "./App.css";

import { ToastProvider } from "./components/popups/ToastProvider";

function App() {
  return (
    <ToastProvider>
      <MainRouters />
    </ToastProvider>
  );
}

export default App;
